import React, { forwardRef } from 'react'
import cx from 'classnames'

const PageHeader = forwardRef(({
  className,
  ...props
}, ref) => {
  const classes = cx(className, 'm-page-header')

  return (
    <header
      className={classes}
      ref={ref}
      {...props}
    />
  )
})

export default PageHeader
